import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=7d351e76&scoped=true&"
import script from "./Moderation.vue?vue&type=script&lang=js&"
export * from "./Moderation.vue?vue&type=script&lang=js&"
import style0 from "./Moderation.vue?vue&type=style&index=0&id=7d351e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d351e76",
  null
  
)

export default component.exports